import { useEffect, useState } from "react";
import api from "../api/api";

function Books() {
  const [books, setBooks] = useState([]);
  const [form, setForm] = useState({ title: "", author: "", isbn: "", copies: 1 });

  const fetchBooks = async () => {
    const res = await api.get("/books/");
    setBooks(res.data);
  };

  useEffect(() => { fetchBooks(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await api.post("/books", form);
    fetchBooks();
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Books</h2>

      <form onSubmit={handleSubmit}>
        <input placeholder="Title" onChange={e => setForm({ ...form, title: e.target.value })} required />
        <input placeholder="Author" onChange={e => setForm({ ...form, author: e.target.value })} required />
        <input placeholder="ISBN" onChange={e => setForm({ ...form, isbn: e.target.value })} required />
        <input type="number" placeholder="Copies" onChange={e => setForm({ ...form, copies: Number(e.target.value) })} />
        <button type="submit">Add Book</button>
      </form>

      <ul>
        {books.map(book => (
          <li key={book._id}>{book.title} by {book.author} (Copies: {book.copies})</li>
        ))}
      </ul>
    </div>
  );
}

export default Books;